function Selector({
  label,
  options,
  selected,
}: {
  label: string;
  options: string[];
  selected: string;
}) {
  return (
    <div class="manifest-control">
      <span>{label}</span>
      <div class="manifest-selector">
        {options.map((option) => (
          <button
            class={option === selected ? "selected" : ""}
            aria-pressed={option === selected}
            key={option}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

type Props = {
  rows?: [string, string, string][];
  onOpenLoremine?: () => void;
};

const defaultRows: [string, string, string][] = [
  ["OPERATOR", "THE ARCHIVIST", "gold"],
  ["HOST", "CODEX", ""],
  ["ROM", "DECKOS 0.1 BETA", ""],
  ["MOUNT", "LOCAL", "cyan"],
  ["FOCUS", "CPU-001", "cyan"],
  ["CONTEXT", "1 CHIP / 5 ROUTES", ""],
  ["IMPRINTS", "3 ACTIVE", "gold"],
  ["TRUTH", "NONE", ""],
  ["RISK", "CLEAR", "green"],
  ["SYNC", "LOCAL / CURRENT", "cyan"],
  ["STORAGE", "AVAILABLE OFFLINE", "green"],
  ["APP VERSION", "0.1.0-BETA.1", ""],
];

export function ManifestScreen({ rows, onOpenLoremine }: Props) {
  const state = rows?.length ? rows : defaultRows;
  return (
    <section class="manifest-screen" aria-labelledby="manifest-title">
      <div class="manifest-heading">
        <span class="eyebrow">OPERATING STATE</span>
        <h1 id="manifest-title">MANIFEST</h1>
      </div>
      <div class="manifest-ledger">
        {state.map(([label, value, tone]) => (
          <div class="manifest-row" key={label}>
            <span>{label}</span>
            <strong class={tone}>{value}</strong>
          </div>
        ))}
      </div>
      {onOpenLoremine && (
        <div class="manifest-tools">
          <div class="section-label">GM TOOLS</div>
          <button type="button" class="deck-chamfer-button" onClick={onOpenLoremine}>
            OPEN LOREMINE REVIEW
          </button>
          <p class="meta">Internal, evidence-backed campaign review.</p>
        </div>
      )}
      <div class="appearance-block">
        <div class="section-label">APPEARANCE</div>
        <Selector
          label="THEME"
          options={["V3KTOR", "ASSEMBLY", "TRON"]}
          selected="V3KTOR"
        />
        <Selector
          label="GLOW INTENSITY"
          options={["LOW", "MEDIUM", "HIGH"]}
          selected="MEDIUM"
        />
        <Selector
          label="GRID DETAIL"
          options={["OFF", "LOW", "HIGH"]}
          selected="LOW"
        />
        <div class="manifest-control">
          <span>REDUCED MOTION</span>
          <button class="motion-switch" aria-pressed="false">
            OFF
          </button>
        </div>
      </div>
    </section>
  );
}
